import { PayrollAction } from '../use-payroll-flow';

type PayrollStep = {
  label: string;
  actions: PayrollAction[];
};

export const PAYROLL_STEPS: PayrollStep[] = [
  { label: 'Payroll setup', actions: ['PAYROLL_SETUP'] },
  {
    label: 'Payroll information',
    actions: [
      'MANUAL_SELECT_BENEFICIARIES',
      'MANUAL_ADD_EMPLOYEES',
      'FINANCIAL_INFORMATION',
      'UPLOAD_DOCUMENT',
      'PAYROLL_DRAFT',
    ],
  },
  { label: 'Approve', actions: ['PAYROLL_SUMMARY'] },
  { label: 'Payment', actions: ['REVIEW_AND_PAY', 'PAYROLL_PAYMENT_SUCCESS', 'COMPLETED_PAYROLL_SUMMARY'] },
];

export const getCurrentStepIndex = (currentAction: PayrollAction | undefined): number => {
  if (!currentAction) return 0;
  return PAYROLL_STEPS.findIndex((step) => step.actions.includes(currentAction));
};
